import apiClient from '../connections/api'

export default {
    getPatterns: () => {
        return apiClient.get('/patterns/getPatterns')
    },
    savePattern: (pattern) => {
        return apiClient.post('/patterns/savePattern', pattern)
    },
    getPatternDetails: () => {
        return apiClient.get('/patterns/getPatternDetails')
    },
    getPatternsFields: async () => {
        const response = await apiClient.get('/patterns/getPatternsFields')
        return response.data
    },
    getPatternsDetailByIdpm: (idpm) => {
        return apiClient.post('/patterns/getPatternsDetailByIdpm', { idpm: idpm })
    },
    getPatternDetailByIdpmAndGuide: async (idpm, typepm) => {
        const response = await apiClient.post('/patterns/getPatternDetailByIdpmAndGuide', { idpm, typepm })
        return response.data
    },
    saveFilesToPattern: (file, patternId) => {
        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('patternId', patternId)
        const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
        }
        return apiClient.post('/patterns/saveFilesToPattern', formData, config)
    }
}
